<script setup>
// One of the three My Event confirm sub-views (double-book / exit-without-saving
// / delete). Presentational only — rendered inside my-event.vue's ModalShell.
defineProps({
    headline: { type: String, default: '' },
    body: { type: String, default: '' },
    primaryLabel: { type: String, required: true },
    secondaryLabel: { type: String, required: true },
    primaryVariant: { type: String, default: 'filled' }, // 'filled' | 'outline'
});
const emit = defineEmits(['primary', 'secondary']);

import { modal_button_filled_2026, modal_button_outline_2026 } from '~~/shared/utilities/ui';

const filled = modal_button_filled_2026;
const outline = modal_button_outline_2026;
</script>

<template>
    <div class="flex flex-col items-center w-full">
        <h2 v-if="headline" class="font-hubspot-serif font-normal text-[25px] sm:text-[30px] leading-[1.3] tracking-normal text-(--magenta) text-center mb-[24px]">
            {{ headline }}
        </h2>

        <div class="flex items-start gap-[12px] w-full text-left bg-white rounded-[10px] p-[20px]">
            <svg class="shrink-0 mt-[2.5px] size-[16px] text-(--magenta)" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <circle cx="8" cy="8" r="8" fill="currentColor" />
                <path d="M8 4V9" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                <circle cx="8" cy="11.6" r="0.9" fill="white" />
            </svg>
            <!-- Slot wins over the plain `body` string, so a caller can supply rich
                 content (e.g. the double-book message with its detail-tray link). -->
            <slot name="body">
                <p class="font-hubspot-sans font-light text-[14px] leading-[1.5] text-(--magenta) m-0">{{ body }}</p>
            </slot>
        </div>

        <div class="flex flex-row flex-wrap justify-center items-center gap-[16px] mt-[32px]">
            <button type="button" :class="primaryVariant === 'outline' ? outline : filled" @click="emit('primary')">{{ primaryLabel }}</button>
            <button type="button" :class="primaryVariant === 'outline' ? filled : outline" @click="emit('secondary')">{{ secondaryLabel }}</button>
        </div>
    </div>
</template>
